import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '../../ui/Tooltip'
import ImageIcon from '../../ui/icons/ImageIcon'
import CommentIcon from '../../ui/icons/CommentIcon'
import { pluralize } from '../../../utils/textHelpers'

const ICON_CLASS = 'tw:text-gray-500 tw:text-xl tw:inline-flex'
const PHOTOS_BTN_CLASS = 'tw:text-gray-500 tw:text-xl! tw:inline-flex '
  + 'tw:bg-transparent tw:border-0 tw:p-0 tw:cursor-pointer'

const photoLabel = count => pluralize(count, 'photo')

const ContentCell = ({ photosCount = 0, hasComment = false, comment = '', onPhotosClick }) => {
  if (photosCount === 0 && !hasComment)
    return <span className="tw:text-gray-500">--</span>
  return (
    <div className="tw:flex tw:items-center tw:gap-2">
      {photosCount > 0 ? (
        <Tooltip content={photoLabel(photosCount)}>
          <button
            aria-label={photoLabel(photosCount)}
            className={PHOTOS_BTN_CLASS}
            type="button"
            onClick={onPhotosClick}
          >
            <ImageIcon />
          </button>
        </Tooltip>
      ) : null}
      {hasComment ? (
        <Tooltip content={comment}>
          <span aria-label="Commentaire" className={ICON_CLASS}>
            <CommentIcon />
          </span>
        </Tooltip>
      ) : null}
    </div>
  )
}

ContentCell.propTypes = {
  comment: PropTypes.string,
  hasComment: PropTypes.bool,
  onPhotosClick: PropTypes.func.isRequired,
  photosCount: PropTypes.number
}

ContentCell.defaultProps = {
  comment: '',
  hasComment: false,
  photosCount: 0
}

export default ContentCell
